import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchDossiersARevoir } from '../redux/slices/demarchesSlice';
import { AppDispatch, RootState } from '../redux/store';
import Layout from '../components/Layout';

const DossiersARevoir: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { demarches, loading } = useSelector((state: RootState) => state.demarches);

  useEffect(() => {
    dispatch(fetchDossiersARevoir());
  }, [dispatch]);

  const getClientName = (demarche: any) => {
    return demarche.type_client === 'entreprise'
      ? demarche.raison_sociale
      : `${demarche.client_nom} ${demarche.client_prenom || ''}`;
  };

  const getDaysUntilReminder = (date: string) => {
    const today = new Date();
    const reminderDate = new Date(date);
    const diffTime = reminderDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const getReminderBadge = (days: number) => {
    if (days < 0) {
      return <span className="badge badge-danger">En retard ({Math.abs(days)}j)</span>;
    } else if (days === 0) {
      return <span className="badge badge-warning">Aujourd'hui</span>;
    } else {
      return <span className="badge badge-info">Dans {days}j</span>;
    }
  };

  return (
    <Layout>
      <h1 style={{ marginBottom: '30px' }}>Dossiers à revoir</h1>

      <div className="card">
        <p style={{ color: '#666', marginBottom: '20px' }}>
          Cette page affiche toutes les démarches nécessitant un suivi selon les rappels programmés.
        </p>

        {loading ? (
          <div className="loading">Chargement...</div>
        ) : !demarches || demarches.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
            <p style={{ fontSize: '18px', marginBottom: '10px' }}>✅ Aucun dossier à revoir</p>
            <p>Tous vos dossiers sont à jour !</p>
          </div>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Client</th>
                <th>Démarche</th>
                <th>Type</th>
                <th>Statut</th>
                <th>Prochain rappel</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {(demarches || []).map((demarche: any) => {
                const days = getDaysUntilReminder(demarche.prochain_rappel);
                return (
                  <tr key={demarche.id} style={{ backgroundColor: days < 0 ? '#fff3cd' : 'white' }}>
                    <td>
                      <Link to={`/clients/${demarche.client_id}`} style={{ textDecoration: 'none', color: '#667eea' }}>
                        {getClientName(demarche)}
                      </Link>
                    </td>
                    <td>{demarche.titre}</td>
                    <td>
                      <span className="badge badge-info">
                        {demarche.type_demarche_nom || 'Non spécifié'}
                      </span>
                    </td>
                    <td>
                      <span className="badge badge-warning">{demarche.statut}</span>
                    </td>
                    <td>
                      {getReminderBadge(days)}
                      <br />
                      <small style={{ color: '#666' }}>{demarche.prochain_rappel}</small>
                    </td>
                    <td>
                      <Link to={`/demarches/${demarche.id}`} className="btn btn-primary" style={{ padding: '6px 12px', fontSize: '12px' }}>
                        Voir
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </Layout>
  );
};

export default DossiersARevoir;
